import StatesTable from "./states-table.vue";

export default StatesTable;



// WEBPACK FOOTER //
// ./src/components/_dashboard/states/table/index.js